var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "platform-icon",
      style: {
        "--platform-width": _vm.size + "px",
        "--platform-height": _vm.size + "px",
      },
    },
    [
      _vm.platform === "whatsapp"
        ? _c("WhatsappSvg", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  delay: [600, 0],
                },
                expression:
                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
              },
            ],
            attrs: { color: "green", content: "Whatsapp" },
          })
        : _vm.platform === "instagram"
        ? _c("Instagram", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  delay: [600, 0],
                },
                expression:
                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
              },
            ],
            attrs: { content: "Instagram" },
          })
        : _vm.platform === "messenger"
        ? _c("MessengerIcon", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  delay: [600, 0],
                },
                expression:
                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
              },
            ],
            attrs: { content: "Messenger" },
          })
        : _vm.platform === "telegram"
        ? _c("TelegramIcon", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  delay: [600, 0],
                },
                expression:
                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
              },
            ],
            attrs: { content: "Telegram" },
          })
        : _vm.platform === "whatsapp-business-api"
        ? _c("WhatsappBusinessIcon", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  delay: [600, 0],
                },
                expression:
                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
              },
            ],
            attrs: { content: "Web", color: "#59c864" },
          })
        : _vm.platform === "whatsapp-v2"
        ? _c("WhatsappV2", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  delay: [600, 0],
                },
                expression:
                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
              },
            ],
            attrs: { content: "Web", color: "#59c864" },
          })
        : _vm.platform === "notWp"
        ? _c("WhatsappSvg", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  delay: [600, 0],
                },
                expression:
                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
              },
            ],
            attrs: {
              color: "red",
              content: "Kanal silinmiş ya da bağlantısı koparılmıştır.",
            },
          })
        : _c("BrowserSvg2", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: {
                  followCursor: true,
                  placement: "bottom-end",
                  delay: [600, 0],
                },
                expression:
                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
              },
            ],
            attrs: { content: "Web" },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }